module.exports = __webpack_public_path__ + "static/media/Detroit.37dd1b75.png";